import type { ResultOf } from '@horof/shared';
import { graphql } from './gql';

/**
 * Reviews (arqam doc 54): one queue for operations, transfers and in-kind
 * contributions; the treasurer clears, the committee may ask.
 */

export type ReviewKind = 'operation' | 'transfer' | 'in_kind';

export const KIND_LABELS: Record<ReviewKind, string> = {
  operation: 'عملية',
  transfer: 'تحويل',
  in_kind: 'مساهمة عينية',
};

/** Everything waiting, the oldest request first. */
export const ReviewQueueDocument = graphql(`
  query DeskReviewQueue($kind: String) {
    financeReviewQueue(kind: $kind, first: 500) {
      totalCount
      nodes {
        kind
        id
        date
        amount
        description
        reviewNote
        reviewRequestedBy
        reviewRequestedAt
        account
        project
        hasReceipt
      }
    }
  }
`);

export type ReviewItem = NonNullable<
  NonNullable<
    ResultOf<typeof ReviewQueueDocument>['financeReviewQueue']
  >['nodes'][number]
>;

/** Set or clear the flag on rows of one kind (treasurer). */
export const SetReviewDocument = graphql(`
  mutation DeskSetReview(
    $kind: String!
    $ids: [UUID]!
    $needsReview: Boolean!
    $note: String
  ) {
    appSetReview(
      input: { kind: $kind, ids: $ids, needsReview: $needsReview, note: $note }
    ) {
      result
    }
  }
`);

/** Ask for a review, with what to check (committee and treasurer). */
export const FlagForReviewDocument = graphql(`
  mutation DeskFlagForReview($kind: String!, $id: UUID!, $note: String!) {
    appFlagForReview(input: { kind: $kind, id: $id, note: $note }) {
      result
    }
  }
`);

/** A row's review stamps and its history, for its panel. */
export const TrailDocument = graphql(`
  query DeskTrail(
    $id: UUID!
    $entity: String!
    $operation: Boolean!
    $transfer: Boolean!
    $inKind: Boolean!
  ) {
    financialOperation(id: $id) @include(if: $operation) {
      id
      needsReview
      reviewRequestedBy
      reviewRequestedAt
      reviewedBy
      reviewedAt
    }
    accountTransfer(id: $id) @include(if: $transfer) {
      id
      needsReview
      reviewRequestedBy
      reviewRequestedAt
      reviewedBy
      reviewedAt
    }
    inKindContribution(id: $id) @include(if: $inKind) {
      id
      needsReview
      reviewRequestedBy
      reviewRequestedAt
      reviewedBy
      reviewedAt
    }
    financeChanges(
      filter: { entity: { equalTo: $entity }, entityId: { equalTo: $id } }
      orderBy: [CHANGED_AT_DESC]
      first: 50
    ) {
      totalCount
      nodes {
        id
        action
        changedBy
        changedAt
        changes
      }
    }
  }
`);
